import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from "react-hook-form";
import {getLanguage, t} from "react-switch-lang";
import SelectInfinite from '../../../../../components/FormFields/SelectInfinite'
import * as yup from "yup";
import {Row, Col, Spinner} from 'react-bootstrap';
import {yupResolver} from "@hookform/resolvers";
import InputText from "../../../../../components/FormFields/InputText";
import InputDate from '../../../../../components/FormFields/inputDate/InputDate'
import TextArea from "../../../../../components/FormFields/Textarea";
import './SpniftLegalComplianceForm.scss';
import {
  createComplianceForm,
  createLegalForm,
  createSpniftForm,
  editComplianceForm,
  editLegalForm,
  editSpniftForm, getAllComplianceRiskLevels, getAllLegalClientAcceptabilities,
  getAllSpniftClientAcceptabilities,
  getComplianceForm,
  getLegalForm,
  getSpniftForm,
} from '../../../../../services/externalizations/spniftLegalComplianceService';
import {format, parseISO} from 'date-fns';
import {Toast} from "../../../../../utils/sweetAlert";
import {useParams} from "react-router-dom";
import {useUserContext} from '../../../../../contexts/UserContext';
import {
  customStyles,
  handleCancelExternalization,
  isUserReviewer, statusesOfVerification,
} from '../../../../../utils/externalizationFormOptions';
import Swal from 'sweetalert2';
import {useExternalizationContext} from '../../../../../contexts/ExternalizationContext';
import FormActionButtons from '../../../components/formActionButtons/FormActionButtons';
import VerifyExternalizationModal from '../../../components/verifyExternalizationModal/VerifyExternalizationModal';

function SpniftLegalComplianceForm({cycleId, isLastCycle, isEditAllowedByStatus, fieldName,name,externalizationFormConfigData}) {

  const [disabled, setDisabled] = useState(false);
  const [defaultData,setDefaultData] = useState([]);
  const [formId, setFormId] = useState()
  const [loading,setLoading] = useState(false);
  const [populated,setPopulated] = useState(false);
  const [showEditBtn,setShowEditBtn] = useState(false);
  const [isReview,setIsReview] = useState(false)
  const [acceptabilityOptions, setAcceptabilityOptions] = useState([]);
  const [riskDescription, setRiskDescription] = useState('')
  const [edit,setEdit] = useState(showEditBtn);
  const [responsibleUserForSpniftForm, setResponsibleUserForSpniftForm] = useState()
  const [responsibleUserForLegalForm, setResponsibleUserForLegalForm] = useState()
  const [responsibleUserForComplianceForm, setResponsibleUserForComplianceForm] = useState()
  const user = useUserContext()
  const externalizationConfigData = useExternalizationContext();
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [verificationStatus, setVerificationStatus]= useState('')
  const canVerify = verificationStatus === 'PENDING'
  const userCanVerifySpniftForm = user?.id === responsibleUserForSpniftForm
  const userCanVerifyLegalForm = user?.id === responsibleUserForLegalForm
  const userCanVerifyComplianceForm = user?.id === responsibleUserForComplianceForm
  const toggleVerifyModal = () => setVerifyModalOpen(prev => !prev);
  const schema = yup.object().shape({
      processingDate: yup.date()
        .nullable()
        .typeError(t('message.fieldRequired'))
        .required(t('message.fieldRequired')),
        [fieldName]: yup.object().nullable().required(t('message.fieldRequired')),
        comment: yup
            .string()
            .trim()
            .max(2000, t('message.max', {max: 2000}))
    });
    const methods = useForm({
        resolver: yupResolver(schema),
    });
    const {handleSubmit, setValue,reset, watch} = methods;
    const watchCustomInput = watch(`${fieldName}`);
    const lang = getLanguage();
    const { id } = useParams();
    useEffect(() => {
        if (defaultData) {
            reset({
                departmentInCharge: defaultData?.departmentInCharge
                    ? {
                        value: defaultData.departmentInCharge.id,
                        label: lang === 'eng' ? defaultData.departmentInCharge.nameEn : defaultData.departmentInCharge.name,
                    }
                    : null,
                [fieldName]: defaultData?.[fieldName] ? {
                    label: lang === 'eng'
                        ? defaultData?.[fieldName]?.nameEn
                        : defaultData?.[fieldName]?.name,
                    value: defaultData?.[fieldName]?.id
                } : null,

                processingDate: defaultData?.processingDate
                    ? parseISO(defaultData.processingDate)
                    : new Date()
            });
        }
    }, [defaultData, reset]);

    const submitForm = async (data) => {
        const formatProcessingDate = format(new Date(data?.processingDate), 'yyyy-MM-dd');
        setDisabled(true);
        const dataToSubmit = {
            processingDate: formatProcessingDate,
            comment: data?.comment,
            [fieldName]: {id:data?.[fieldName].value},
            ...(edit && {
                id: defaultData?.id ? defaultData?.id : formId,
            }),
          populated: true,
          cycle: {id: parseInt(cycleId)},
          formConfig: externalizationFormConfigData,
          userInCharge: {id: externalizationFormConfigData?.defaultDepartment?.userInChargeForExternalizationId},
          responsibleUser: {id: externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId}
        };
      if(name==='spniftForm') {
        if (edit) {
          try{
          const res = await editSpniftForm(defaultData?.id ? defaultData?.id : formId, dataToSubmit)
            if (res?.status === 200) {
              Toast.fire({
                title: t('message.updateSuccess2', {
                  entity: t('externalization.SPNIFTForm.spniftSector'),
                }),
                icon: 'success',
              });
              const newVerificationStatus = res?.data?.verificationStatus;
              if (newVerificationStatus && newVerificationStatus !== verificationStatus) {
                setTimeout(() => {
                  window.location.reload();
                }, 800);
              } else {
                setVerificationStatus(newVerificationStatus);
                setDisabled(true);
              }
            }
            setDisabled(true);
          } catch (err){
            if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
              Swal.fire({
                text:
                  lang === 'eng'
                    ? err.response.data.description
                    : t('message.responsibleUserForExternalizationMissing'),
                icon: 'error',
              });
              setDisabled(false)
              setEdit(false)
            } else {
              Toast.fire({
                title: t('message.errorApi'),
                icon: 'error',
              });
            }
          }
        } else {
          try {
            const response = await createSpniftForm(dataToSubmit)
            if (response?.status === 201) {
              Toast.fire({
                title: t('message.addSuccess2', {
                  entity: t('externalization.SPNIFTForm.spniftSector'),
                }),
                icon: 'success',
              });
              setEdit(true)
              setDisabled(true)
              setIsReview(true)
              setVerificationStatus('PENDING')
              setFormId(response?.data?.id)
              setResponsibleUserForSpniftForm(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
            }
          }catch (err){
            if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
              Swal.fire({
                text:
                  lang === 'eng'
                    ? err.response.data.description
                    : t('message.responsibleUserForExternalizationMissing'),
                icon: 'error',
              });
              setDisabled(false)
              setEdit(false)
            } else {
              Toast.fire({
                title: t('message.errorApi'),
                icon: 'error',
              });
            }
          }
        }
      }
        else if(name === 'legalForm') {
            if(edit) {
              try{
                const res = await editLegalForm(defaultData?.id ? defaultData?.id : formId,dataToSubmit)
                    if (res?.status === 200) {
                        Toast.fire({
                            title: t('message.updateSuccess', {
                                entity: t('externalization.SPNIFTForm.legalSector'),
                            }),
                            icon: 'success',
                        });
                      const newVerificationStatus = res?.data?.verificationStatus;
                      if (newVerificationStatus && newVerificationStatus !== verificationStatus) {
                        setTimeout(() => {
                          window.location.reload();
                        }, 800);
                      } else {
                        setVerificationStatus(newVerificationStatus);
                        setDisabled(true);
                      }
                    }
                  setDisabled(true);
                } catch (err){
                if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
                  Swal.fire({
                    text:
                      lang === 'eng'
                        ? err.response.data.description
                        : t('message.responsibleUserForExternalizationMissing'),
                    icon: 'error',
                  });
                  setDisabled(false)
                  setEdit(false)
                } else {
                  Toast.fire({
                    title: t('message.errorApi'),
                    icon: 'error',
                  });
                }
              }
            }else {
              try {
                const response = await createLegalForm(dataToSubmit)
                    if (response?.status === 201) {
                        Toast.fire({
                            title: t('message.addSuccess', {
                                entity: t('externalization.SPNIFTForm.legalSector'),
                            }),
                            icon: 'success',
                        });
                        setDisabled(true)
                        setEdit(true)
                        setIsReview(true)
                      setVerificationStatus('PENDING')
                      setFormId(response?.data?.id)
                      setResponsibleUserForLegalForm(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
                    }
                }
              catch (err){
                if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
                  Swal.fire({
                    text:
                      lang === 'eng'
                        ? err.response.data.description
                        : t('message.responsibleUserForExternalizationMissing'),
                    icon: 'error',
                  });
                  setDisabled(false)
                  setEdit(false)
                } else {
                  Toast.fire({
                    title: t('message.errorApi'),
                    icon: 'error',
                  });
                }
              }
            }
        }
        else if(name === 'complianceForm') {
            if(edit) {
              try{
                const res = await editComplianceForm(defaultData?.id ? defaultData?.id : formId,dataToSubmit)
                    if (res?.status === 200) {
                        Toast.fire({
                            title: t('message.updateSuccess2', {
                                entity: t('externalization.SPNIFTForm.complianceSector'),
                            }),
                            icon: 'success',
                        });
                      const newVerificationStatus = res?.data?.verificationStatus;
                      if (newVerificationStatus && newVerificationStatus !== verificationStatus) {
                        setTimeout(() => {
                          window.location.reload();
                        }, 800);
                      } else {
                        setVerificationStatus(newVerificationStatus);
                        setDisabled(true);
                      }
                    }
                  setDisabled(true);
                } catch (err){
                  if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
                    Swal.fire({
                      text:
                        lang === 'eng'
                          ? err.response.data.description
                          : t('message.responsibleUserForExternalizationMissing'),
                      icon: 'error',
                    });
                    setDisabled(false)
                    setEdit(false)
                  } else {
                    Toast.fire({
                      title: t('message.errorApi'),
                      icon: 'error',
                    });
                  }
                }
            }else {
              try {
                const response = await createComplianceForm(dataToSubmit)
                    if (response?.status === 201) {
                        Toast.fire({
                            title: t('message.addSuccess2', {
                                entity: t('externalization.SPNIFTForm.complianceSector'),
                            }),
                            icon: 'success',
                        });
                        setDisabled(true)
                        setEdit(true)
                        setIsReview(true)
                      setVerificationStatus('PENDING')
                      setFormId(response?.data?.id)
                      setResponsibleUserForComplianceForm(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
                    }
                }
      catch (err){
          if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
            Swal.fire({
              text:
                lang === 'eng'
                  ? err.response.data.description
                  : t('message.responsibleUserForExternalizationMissing'),
              icon: 'error',
            });
            setDisabled(false)
            setEdit(false)
          } else {
            Toast.fire({
              title: t('message.errorApi'),
              icon: 'error',
            });
          }
        }
            }
        }

    }
    useEffect(() => {
      name === "spniftForm" ?
        getSpniftForm(cycleId).then((res) => {
          const form = res?.data?.[0] ?? null;
          if (form) {
            setDefaultData(form);
            setResponsibleUserForSpniftForm(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
            setPopulated(!!form?.populated);
            setEdit(!!form?.populated);
            setDisabled(!!form?.populated);
            setVerificationStatus(form?.verificationStatus)
            setIsReview(!!form?.populated && isUserReviewer(externalizationConfigData,user,'spniftForm'));
            setShowEditBtn(!form?.populated === false || !isUserReviewer(externalizationConfigData,user,'spniftForm'));
          }if(res.data[0]?.populated) {
              setPopulated(false);
              setEdit(true);
            }else {
              setValue('processingDate', new Date());
              setEdit(false)
              setDisabled(!isUserReviewer(externalizationConfigData,user,'spniftForm'));
            }
          })
:  name === "legalForm" ?
     getLegalForm(cycleId).then((res) => {
                const form = res?.data?.[0] ?? null;
                if (form) {
                    setDefaultData(form);
                  setResponsibleUserForLegalForm(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
                    setPopulated(!!form?.populated);
                    setEdit(!!form?.populated);
                    setDisabled(!!form?.populated);
                  setVerificationStatus(form?.verificationStatus)
                    setIsReview(!!form?.populated && isUserReviewer(externalizationConfigData,user,'legalForm'));
                    setShowEditBtn(!form?.populated === false || !isUserReviewer(externalizationConfigData,user,'legalForm'));
                } if(res.data[0]?.populated) {
                setPopulated(false);
                setEdit(true);
              }else {
                setValue('processingDate', new Date());
                setEdit(false)
                setDisabled(!isUserReviewer(externalizationConfigData,user,'legalForm'));
              }
            })
        :
              getComplianceForm(cycleId).then((res) => {
                const form = res?.data?.[0] ?? null;
                if (form) {
                    setDefaultData(form);
                    setResponsibleUserForComplianceForm(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
                    setPopulated(!!form?.populated);
                    setEdit(!!form?.populated);
                    setDisabled(!!form?.populated);
                  setVerificationStatus(form?.verificationStatus)
                  setIsReview(!!form?.populated && isUserReviewer(externalizationConfigData,user,'complianceForm'));
                    setShowEditBtn(!form?.populated === false || !isUserReviewer(externalizationConfigData,user,'complianceForm'));
                }  if(res.data[0]?.populated) {
          setPopulated(false);
          setEdit(true);
        }else {
          setValue('processingDate', new Date());
          setEdit(false)
          setDisabled(!isUserReviewer(externalizationConfigData,user,'complianceForm'));
        }
      })
    }, [cycleId]);
  useEffect(() => {
    if (watchCustomInput) {
      setValue('riskAssessment', watchCustomInput);
    }
  }, [watchCustomInput, setValue]);
  useEffect(() => {
    name === "spniftForm" ?
    getAllSpniftClientAcceptabilities().then((res) => {
      if (res?.data) {
        setAcceptabilityOptions(res.data);
      }
    })
    : name === "legalForm" ?
        getAllLegalClientAcceptabilities().then((res) => {
        if (res?.data) {
          setAcceptabilityOptions(res.data);
        }
      })
    :
        getAllComplianceRiskLevels().then((res) => {
      if (res?.data) {
        setAcceptabilityOptions(res.data);
      }
    });
  }, []);
  useEffect(() => {
    if (watchCustomInput && acceptabilityOptions.length > 0) {
      const selected = acceptabilityOptions.find(
        (item) => item.id === watchCustomInput.value
      );
      const description = lang === 'mne'
        ? selected?.description
        : selected?.descriptionEn;
      setRiskDescription(description || '');
    }
  }, [watchCustomInput, acceptabilityOptions, lang]);

    if (loading) {
        return (
            <div className="text-center mt-4 mb-4">
                <Spinner animation="border" role="status" />
            </div>
        );
    }
    return (<>
      <FormActionButtons
        isReview={isReview}
        edit={edit}
        disabled={disabled}
        isLastCycle={isLastCycle}
        isEditAllowedByStatus={isEditAllowedByStatus}
        userCanVerifyForm={ name === "spniftForm" ? userCanVerifySpniftForm : name === 'legalForm' ? userCanVerifyLegalForm : userCanVerifyComplianceForm}
        canVerify={canVerify}
        toggleVerifyModal={toggleVerifyModal}
        setDisabled={setDisabled}
      />
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(submitForm)}>
                <Row className="mb-5 w-100">
                    <Col className="col-6 col-xl-3">
                        <label className="label w-100 mt-2">
                            {t('departments.department')}
                        </label>
                        <SelectInfinite
                            api="departments"
                            name="departmentInCharge"
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            className="select"
                            isDisabled={true}
                            defaultValue={{label: lang === 'eng' ? externalizationFormConfigData?.defaultDepartment?.nameEn : externalizationFormConfigData?.defaultDepartment?.name,
                                value: externalizationFormConfigData?.defaultDepartment?.id}}
                        />
                      <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.date')}
                      </label>
                      <InputDate
                        name="processingDate"
                        className={'date-input'}
                        defaultValue={defaultData?.processingDate !== undefined ? format(new Date(defaultData?.processingDate), 'yyyy-MM-dd') : new Date()}
                        disabled={disabled}
                      />
                    </Col>
                    <Col className="col-6 col-xl-3">
                        <label className="label w-100 mt-2" htmlFor={fieldName}>
                            {t(`externalization.SPNIFTForm.${fieldName}`)}
                        </label>
                      <SelectInfinite
                        api={name === "spniftForm" ? "spnift-client-acceptabilities" :
                          name === "legalForm"
                            ? "legal-client-acceptabilities"
                            : "compliance-risk-levels"}
                        name={fieldName}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={disabled}
                        placeholder={t(`externalization.SPNIFTForm.placeholder.${fieldName}`)}
                    />
                      <label className="label w-100 mt-2" htmlFor="riskssessment">
                        {t('externalization.riskProponentForm.riskAssessment')}
                      </label>
                      <SelectInfinite
                        api={"spnift-client-acceptabilities"}
                        name="riskAssessment"
                        defaultValue={
                          watchCustomInput
                            ? {
                              label: watchCustomInput?.label,
                              value: watchCustomInput?.value,
                            }
                            : null
                        }
                        isDisabled={true}
                        placeholder={''}
                        styles={customStyles}
                      />
                      <label className="label w-100 mt-2">
                        {t('externalization.sectorAML.riskDescription')}
                      </label>
                      <textarea
                        key={riskDescription}
                        value={riskDescription}
                        type="text"
                        defaultValue={lang === 'mne' ? defaultData?.[fieldName]?.description : defaultData?.[fieldName]?.descriptionEn}
                        disabled={true}
                        rows={4}
                      />
                      <label className="label w-100 mt-2">
                        {t('comments.comment')}
                        <span className="optional register line-height">
                  {t('common.optional')}
                </span>
                      </label>
                      <TextArea
                        name="comment"
                        className={`form-control text-area `}
                        placeholder={t('placeholder.comment')}
                        disabled={disabled}
                        defaultValue={defaultData?.comment}
                      />
                    </Col>
                        <Col className="col-6 col-xl-3">
                          <label className="label w-100 mt-2">
                            {t('externalization.analysisDoneBy')}
                          </label>
                          <InputText
                            type="text"
                            name="userInCharge"
                            className="form-control input-field"
                            disabled={true}
                            id="userInCharge"
                            defaultValue={externalizationFormConfigData?.defaultDepartment?.userInChargeForExternalizationFullName}
                          />
                          {externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName && <>
                          <label className="label w-100 mt-2">{t('departments.userInChargeReplacementForExternalization')}</label>
                          <InputText
                            type="text"
                            name="userInChargeDeputy"
                            className="form-control input-field"
                            disabled={true}
                            id="userInCharge"
                            defaultValue={externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName}
                          /></>}
                          <label className="label w-100 mt-2">
                            {t('externalization.verificationDoneBy')}
                          </label>
                          <InputText
                            type="text"
                            name="responsibleUser"
                            className="form-control input-field"
                            disabled={true}
                            id="responsibleUser"
                            defaultValue={externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationFullName}
                          />
                          {edit && <>  <label className="label w-100 mt-2">{t('externalization.verificationStatus')}</label>
                            <InputText
                              name="verificationStatus"
                              type="text"
                              className="form-control input-field"
                              placeholder={t( 'externalization.placeholder.verificationStatus')}
                              disabled={true}
                              defaultValue={statusesOfVerification.find(
                                (status) => status.value === verificationStatus)?.label}
                            /></>}
                        </Col>
                </Row>
                {(!edit || (edit && !disabled)) && isUserReviewer(externalizationConfigData, user, name === "spniftForm" ? "spniftForm" :
                  name === "legalForm"
                    ? "legalForm"
                    : "complianceForm") && <Row className="mt-5 mb-3 form-footer">
                    <button
                        className="secondary-btn"
                        type="reset"
                        onClick={handleCancelExternalization}>
                        {t('buttons.cancel')}
                    </button>
                    <button type={'submit'} disabled={disabled} className="primary-btn">{t('buttons.save')}</button>
                </Row>}
            </form>
        </FormProvider>
      <VerifyExternalizationModal
        open={verifyModalOpen}
        formType={externalizationFormConfigData?.formKey}
        formId={defaultData?.id ? defaultData?.id : formId}
        isOpen={setVerifyModalOpen}
      />
    </>);
}

export default SpniftLegalComplianceForm;